import { Injectable } from "@angular/core";
import { TicksAgoService } from "../chart/ticks-ago.service";

@Injectable()
export class StatsNormalizerService {
  constructor(private ticksAgoService: TicksAgoService) {}

  public populateEmptyDaysWithZeros(
    stats: number[],
    time: string[],
    dur: any,
    lastN: any,
  ) {
    const ticks = this.ticksAgoService.ticksFor(dur, lastN);

    return ticks.map((tick: Date) => {
      let value = 0;

      time.forEach((timestamp: string, i: number) => {
        if (new Date(timestamp).getTime() === tick.getTime()) {
          value = stats[i];
        }
      });

      return value;
    });
  }
}
